export default {"src":"/_next/static/media/nameContact.07369546.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};